import React from "react";
import { ResponsiveLine } from "@nivo/line";
import styled from "styled-components";

function GraphComponent({ data }) {
  if (!data) return null;

  const forecast = data?.["Forecast"]?.[0] || {};
  const qty = data?.["Quantity to be ordered (EOQ)"]?.[0] || {};

  const keys = Object.keys(forecast);

  const lineData = [
    {
      id: "Forecast",
      color: "#032B4E",
      data: keys.map((key) => ({
        x: key,
        y: Number(forecast[key] ?? 0),
      })),
    },
    {
      id: "Quantity to be ordered (EOQ)",
      color: "#E06639",
      data: keys.map((key) => ({
        x: key,
        y: Number(qty[key] ?? 0),
      })),
    },
  ];

  return (
    <Wrapper>
      <Card>
        <h2 className="chart-title">Inventory Analysis</h2>

        <div className="chart-wrapper">
          <ResponsiveLine
            data={lineData}
            margin={{ top: 12, right: 28, bottom: 40, left: 50 }}
            xScale={{ type: "point" }}
            yScale={{
              type: "linear",
              min: 0,
              max: "auto",
              stacked: false,
              reverse: false,
            }}
            curve="linear"
            axisTop={null}
            axisRight={null}
            axisBottom={{
              tickSize: 4,
              tickPadding: 4,
              tickRotation: 0,
              legend: "",
              legendPosition: "middle",
              legendOffset: 36,
            }}
            axisLeft={{
              tickSize: 4,
              tickPadding: 4,
              tickRotation: 0,
              legend: "",
              legendPosition: "middle",
              legendOffset: -40,
            }}
            colors={{ datum: "color" }}
            pointSize={7}
            pointColor={{ theme: "background" }}
            pointBorderWidth={2}
            pointBorderColor={{ from: "serieColor" }}
            enableGridY={true}
            gridYValues={5}
            enableArea={false}
            useMesh={true}
            enableSlices="x"
            lineWidth={2.5}
            theme={{
              background: "#ffffff",
              textColor: "#0c3c54",
              fontSize: 11,
              fontFamily: "Poppins, sans-serif",
              axis: {
                domain: {
                  line: {
                    stroke: "#032B4E",
                    strokeWidth: 1,
                  },
                },
                legend: {
                  text: {
                    fontSize: 11,
                    fontWeight: 600,
                    fontFamily: "Poppins, sans-serif",
                    fill: "#0c3c54",
                  },
                },
                ticks: {
                  line: {
                    stroke: "#032B4E",
                    strokeWidth: 1,
                  },
                  text: {
                    fontSize: 11,
                    fontWeight: 500,
                    fontFamily: "Poppins, sans-serif",
                    fill: "#6a7d8c",
                  },
                },
              },
              grid: {
                line: {
                  stroke: "#e6eef4",
                  strokeWidth: 1,
                },
              },
              legends: {
                text: {
                  fontSize: 11,
                  fontWeight: 600,
                  fontFamily: "Poppins, sans-serif",
                  fill: "#0c3c54",
                },
              },
            }}
            animate={true}
            motionConfig="slow"
            role="application"
            ariaLabel="Inventory line chart"
          />
        </div>
        <div className="chart-legend">
          <span className="legend-item">
            <i className="legend-dot legend-dot-qty" />
            Quantity to be ordered (EOQ)
          </span>
          <span className="legend-item">
            <i className="legend-dot legend-dot-forecast" />
            Forecast
          </span>
        </div>
      </Card>
    </Wrapper>
  );
}

export default GraphComponent;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  padding: 0;
  background: transparent;
`;

const Card = styled.div`
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 3px 12px rgba(12, 60, 84, 0.06);
  padding: 10px 12px 6px;
  text-align: center;
  border: 1px solid #e6eef4;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;

  .chart-title {
    font-size: 15px;
    font-weight: 700;
    font-family: Poppins, sans-serif;
    color: #0c3c54;
    margin: 0 0 6px;
    text-align: center;
    flex-shrink: 0;
  }

  .chart-wrapper {
    flex: 1;
    min-height: 0;
    background: #ffffff;
    border-radius: 8px;
    padding: 4px;
    border: 1px solid #e6eef4;
    position: relative;
    overflow: visible;
  }

  .chart-wrapper > div {
    height: 100% !important;
    min-width: 0;
  }

  .chart-legend {
    margin-top: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    font-family: Poppins, sans-serif;
    font-size: 12px;
    color: #0c3c54;
    line-height: 1.2;
  }

  .legend-item {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-weight: 600;
    white-space: nowrap;
  }

  .legend-dot {
    width: 9px;
    height: 9px;
    border-radius: 999px;
    display: inline-block;
  }

  .legend-dot-qty {
    background: #E06639;
  }

  .legend-dot-forecast {
    background: #032B4E;
  }
`;
